var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 278 370"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D7D8EB",
    d: "M56.07 165.278C47.303 86.718 93.219 31.466 179.328 0c-52.726 68.381 44.952 142.454 50.345 213.455 12.624-21.53 19.795-50.255 21.211-88.676 64.566 101.232 11.027 266.69-131.061 242.902-13.046-2.167-25.61-6.293-37.059-12.435C30.942 327.604 0 267.353 0 209.811c0-36.675 15.697-69.405 36.004-95.421 2.712 25.474 8.497 44.474 20.066 50.888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E5FE",
    d: "M102.048 278.765c-14.643-37.789-12.624-98.823 28.382-120.232.301 70.158 69.447 79.101 56.642 153.986 11.811-13.369 17.776-34.748 18.831-51.64 18.74 42.878 4.037 77.174-22.687 94.638-81.258 53.116-151.218-54.56-104.699-113.577 1.416 13.188 17.566 33.543 23.531 36.825"
  })));
};
export { SvgFlame as ReactComponent };